import type { Rect } from '@view-model/models/common/basic/Rect';
import { ReadonlyFrame } from './ReadonlyFrame';
import { ResizableFrame } from './ResizableFrame';
import type { GetGuardProps } from '@model-framework/drag-file/useDragFileGuard';

type Props = {
  readonly: boolean;
  isMeaningPanel?: boolean;
  viewRect: Rect;
  onResizeStart(): void;
  onResizeEnd(viewRect: Rect): void;
  getGuardProps: GetGuardProps;
};

export const ViewSelectionFrame: React.FC<Props> = ({
  readonly,
  isMeaningPanel = false,
  viewRect,
  onResizeStart,
  onResizeEnd,
  getGuardProps,
}: Props) => {
  return readonly ? (
    <ReadonlyFrame viewRect={viewRect} />
  ) : (
    <ResizableFrame
      viewRect={viewRect}
      isMeaningPanel={isMeaningPanel}
      onResizeStart={onResizeStart}
      onResizeEnd={onResizeEnd}
      getGuardProps={getGuardProps}
    />
  );
};
